<template>
  <div class="mb-4">
    <topbar
      :titulo="$t('ACADEMICO.BOLETIM')"
      :subtitulo="$t('ACADEMICO.BOLETIM_DESCRICAO')"
      :breadcrumbs="breadcrumbs"
    />

    <filtro ref="filtroRef" @filtrar="filtrar" @limparFiltro="limparFiltro" @change="reiniciarPaginacao" />

    <b-table
      :fields="colunasTabela"
      :items="resultadoBusca"
      responsive="sm"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      class="mt-3"
      selectable
      show-empty
      striped
      hover
      @sort-changed="novaOrdenacao"
    >
      <template #cell(acoes)="item">
        <b-button
          variant="primary"
          @click="processarBoletim(item)"
          v-if="podeEditar"
        >
          {{ $t('ACADEMICO.PROCESSAR_BOLETIM') }}
        </b-button>
      </template>
    </b-table>

    <paginacao v-model="paginacao" :total="paginacao.total" @input="filtrar" />

    <modal-boletim
      :filtro="filtroAplicado"
      :exibir="exibirModalBoletim"
      @fechar="fecharModalBoletim"
      :form="alunoSelecionado"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';
// Services:
import PessoaService from '@/common/services/pessoa/pessoa.service';
// Components:
import Filtro from './components/Filtro.vue';
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Paginacao from '@/components/paginacao/Paginacao';
import ModalBoletim from './components/ModalBoletim.vue';

export default {
  mixins: [Permissoes],
  components: {
    Topbar,
    Filtro,
    Paginacao,
    ModalBoletim,
  },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO_HOME.PAINEL_ACADEMICO') },
        { titulo: this.$t('ACADEMICO.BOLETIM') },
      ],
      colunasTabela: [
          {
            key: 'codigoMatricula',
            label: this.$t('ACADEMICO.MATRICULA'),
            sortable: true,
          },
          {
            key: 'nomeAluno',
            label: this.$t('GERAL.NOME'),
            sortable: true,
          },
          {
            key: 'acoes',
            label: this.$t('GERAL.ACOES'),
          },
      ],
      filtroAplicado: {},
      resultadoBusca: [],
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      campoOrdenado: null,
      ordem: false,
      alunoSelecionado: {},
      exibirModalBoletim: false,
    };
  },
  methods: {
    fecharModalBoletim() {
      this.exibirModalBoletim = false;
      this.alunoSelecionado = {};
    },
    processarBoletim({ item }) {
      this.alunoSelecionado = item;
      this.exibirModalBoletim = true;
    },
    reiniciarPaginacao() {
      this.paginacao = {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      }
    },
    filtrar() {
      this.filtroAplicado = this.$refs.filtroRef.filtro;
      this.$store.dispatch(START_LOADING);
      PessoaService.obterAlunosParaBoletim(this.filtroAplicado, this.paginacao, this.campoOrdenado, this.ordem)
        .then(({ data }) => {
          this.resultadoBusca = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    limparFiltro() {
      this.resultadoBusca = [];
      this.filtroAplicado = {};
    },
    novaOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc

      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.filtrar();
    }, 
  },
};
</script>
